import * as React from 'react';
import { utils } from '@blend/ui-common';
import { WindowWrapper } from 'login-utils/globalWrappers';
import BrandLogo from 'login-components/Common/BrandLogo/BrandLogo';

class Emblem extends React.PureComponent {
  render() {
    const { loginLogoUrl, name } = WindowWrapper.DEPLOYMENT_CONFIG.organization;
    const cdnLogoUrl = utils.assetUtils.getCdnUrl(loginLogoUrl);
    return <BrandLogo logoUrl={cdnLogoUrl} name={name} />;
  }
}

export default Emblem;
